export default "__VITE_PUBLIC_ASSET__f57b8581__"